// extracted by css-extract-rspack-plugin
export default {"root":"NotificationIcon_root__0MaZD"};